export default __webpack_public_path__ + "static/media/banner.968c9b2b.svg";